module.exports = __webpack_public_path__ + "img/智能合约开发.c7f35318.png";